import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LoginService } from '@app/services/login.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-autenticacao-dois-fatores',
  templateUrl: './autenticacao-dois-fatores.component.html',
  styleUrls: ['./autenticacao-dois-fatores.component.scss']
})
export class AutenticacaoDoisFatoresComponent implements OnInit {

  codigoForm: FormGroup;
  producao: boolean = false;
  carregando: boolean = false;
  login: string = '';
  senha: string = '';

  constructor(
    private loginService: LoginService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router) {

    this.codigoForm = this.fb.group({code: this.fb.array(
      new Array(6).fill('').map(() => this.fb.control('', Validators.required)))
    });
  }

  ngOnInit(): void {
    if (environment.PRODUCAO) {
      this.producao = true;
    }

    const login = localStorage.getItem('Cardeal.Login');
    const senha = localStorage.getItem('Cardeal.Senha');

    this.carregando = true;
    this.loginService.autenticacaoDoisFatores(login, senha).subscribe(
      (response) => {
        this.carregando = false;
        this.toastr.success('Código enviado');
      },
      (error) => {
        this.toastr.error('Não foi possível enviar o código');
      }
    );
  }

  get codControls() {
    return (this.codigoForm.get('code') as FormArray).controls;
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    this.carregando = false;

    if (value.length > 1) {
      input.value = value[0];
    }

    const formArray = this.codigoForm.get('code') as FormArray;
    formArray.at(index).setValue(input.value);

    if (input.value && index < this.codControls.length - 1) {
      const proxInput = document.querySelectorAll<HTMLInputElement>('.code-input')[index + 1];
      proxInput?.focus();
    }
  }

  onKeydown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      const Input = document.querySelectorAll<HTMLInputElement>('.code-input')[index - 1];
      Input?.focus();
    }
  }

  onSubmit() {
    const codigo = this.codControls.map(control => control.value).join('');

    if (codigo.length !== 6) {
      this.toastr.error('Por favor, preencha todos os campos');
      return;
    }

    const login = localStorage.getItem('Cardeal.Login');
    const senha = localStorage.getItem('Cardeal.Senha');

    this.loginService.verificarCodigo(codigo, login, senha).subscribe(
      (data: any) => {
        localStorage.setItem('Cardeal.Token', data.AccessToken);
        localStorage.setItem('Cardeal.Usuario', JSON.stringify(data.NomeUsuario));

        this.router.navigate(['/dashboard']);
        this.carregando = false;
      },
      (error) => {
        if (error.error && Array.isArray(error.error.message)) {
            error.error.message.forEach((message: { Valor: string }) => {
                this.toastr.error(message.Valor);
            });
        } else {
            this.toastr.error('Erro ao verificar código.');
        }

        setTimeout(() => {
          const formArray = this.codigoForm.get('code') as FormArray;
          formArray.clear();
          for (let i = 0; i < 6; i++) {
            formArray.push(this.fb.control('', Validators.required));
          }

          const firstInput = document.querySelectorAll<HTMLInputElement>('.code-input')[0];
          firstInput?.focus();
        }, 1000);
      }
    );
  }

  onPaste(event: ClipboardEvent, index: number) {
    event.preventDefault();

    const paste = event.clipboardData?.getData('text');
    const formArray = this.codigoForm.get('code') as FormArray;
    const textToPaste = paste.slice(0, formArray.length);

    textToPaste.split('').forEach((char, i) => {
      if (formArray.at(i)) {
        formArray.at(i).setValue(char);
      }
    });

    textToPaste.split('').forEach((char, i) => {
      const input = document.querySelectorAll<HTMLInputElement>('.code-input')[i];
      if (input) {
        input.value = char;
      }
    });

    const nextIndex = Math.min(index + textToPaste.length, formArray.length - 1);
    const nextInput = document.querySelectorAll<HTMLInputElement>('.code-input')[nextIndex];
    nextInput?.focus();
  }
}
